@if (!isInline) {
    <div class="container" [ngClass]="{'dialog-background': data}">
        <ng-container class="images" *ngFor="let item of avatars">
            <img (click)="onSelect(item)" [src]="item.url" [ngClass]="{'item-border' : photoUrl() == item.id && !useNftAvatar}" ondragstart="return false;"/>
        </ng-container>
    </div>
} @else {
    <swiper
        avatar_swiper
        [config]="sliderOptions"
        class="swiper"
        #avatarSlide
    >
        <ng-template
            swiperSlide
            *ngFor="let item of avatars; trackBy: trackAvatars"
        >
            <img
                (click)="onSelect(item)"
                [src]="item.url"
                [ngClass]="{'item-border' : photoUrl() == item.id && !useNftAvatar}"
                ondragstart="return false;"
            />
        </ng-template>
    </swiper>
}
